<template>
    <div v-if="!isLoading"> 
        <v-container>
            <v-form>
                <v-row class="px-8">
                    <h2 class="pb-5">{{ this.parentObject.pageTitle }}</h2>
                </v-row>
                <v-row class="mb-4">
                    <v-col cols="3" sm="3" class="pb-n4 mt-n8">
                        <v-btn color="warning" v-on:click="goBack">{{ $t('button.back') }}</v-btn>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="6" sm="6" class="pb-n4 mt-n8">
                        <v-text-field outlined :label="$t('pmassementrecord.pmassessmentdesc')" type="text" v-model="formData.pmassessmentrecorddesc" readonly
                        dense class="v-input" background-color="#ffeab2"></v-text-field>
                    </v-col>
                    <v-col cols="2" sm="2" class="pb-n4 mt-n8">
                        <v-text-field outlined :label="$t('pmassementrecord.pmassessmentcode')" type="text" v-model="formData.pmassessmentrecordcode" readonly
                            dense class="v-input" background-color="#ffeab2"></v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="2" sm="2" class="pb-n4 mt-n8">
                        <v-text-field outlined :label="$t('pmmoderation.periodfromdate')" type="date" ref="startdate"
                            :rules="[rules.required]" v-model="formData.startdate" dense 
                            class="v-input" readonly background-color='#ffeab2'
                        ></v-text-field>
                    </v-col>
                    <v-col cols="2" sm="2" class="pb-n4 mt-n8">
                        <v-text-field outlined :label="$t('pmmoderation.perioduntildate')" type="date" ref="enddate"
                            :rules="[rules.required]" v-model="formData.enddate" dense 
                            class="v-input" readonly background-color='#ffeab2'
                        ></v-text-field>    
                    </v-col>
                </v-row>
                <v-row>
                    <h2 style="color: #3674cd">{{ this.parentObject.company }}</h2> 
                    <v-btn 
                        icon 
                        color="primary" 
                        @click="goToCompanyDetails()"
                        small
                    >
                        <v-icon small>mdi-pen</v-icon>
                    </v-btn>
                </v-row>
                <v-row>
                    <v-col cols="4" sm="4">
                        <v-select
                            v-model="selectedGroupType"
                            :items="groupTypes"
                            :label="$t('reportstaffenquiry.grpby')"
                            outlined
                            dense
                            @change="generateGroupedCharts"
                        ></v-select>
                    </v-col>
                </v-row>

                <v-row>
                    <v-col 
                        v-for="(chart, groupName) in companyCharts" 
                        :key="groupName" 
                        cols="4" sm="4"
                        style="padding-right: 10px"
                    >
                        <div class="d-flex align-center justify-space-between mb-2">
                            <h4 class="mb-0" style="font-size: 1.1rem; color: #3d4be3">
                                {{ groupName }}
                            </h4>
                            <v-btn 
                                icon 
                                color="primary" 
                                @click="goToGroupDetails(groupName)"
                                small
                            >
                                <v-icon small>mdi-pen</v-icon>
                            </v-btn>
                        </div>
                        <apexchart 
                            :options="chart.chartOptions" 
                            :series="chart.series" 
                            type="line" 
                            height="350"
                        ></apexchart>
                    </v-col>
                </v-row>
            </v-form>
        </v-container>
    </div>
</template>

<script>
import moment from 'moment';
import VueApexCharts from "vue-apexcharts";

export default {
    props: {
        parentObject: Object
    },

    components: {
        'apexchart': VueApexCharts
    },

    data() {
        return {
            rules: {
                required: value => !!value || this.$t('reportsparam.required'),
            },

            formData: {//we getting data and set to the column
                id: this.parentObject.data.id,
                pmassessmentrecordcode: this.parentObject.data.pmassessmentrecordcode,
                pmassessmentrecorddesc: this.parentObject.data.pmassessmentrecorddesc,
                startdate: this.parentObject.data.startdate,
                enddate: this.parentObject.data.enddate,
                ratingtype: this.parentObject.data.ratingtype,
                ratingid: this.parentObject.data.ratingid,
                userid: this.$store.getters.userId,
            },

            errMsg: '',
            isErr: false,
            isEdit: this.parentObject.isEdit,

            companyCharts: {},

            selectedGroupType: 'Department', // Default selection
            groupTypes: [
                { text: 'Department', value: 'Department' },
                { text: 'Branch', value: 'Branch' },
                { text: 'Division', value: 'Division' },
                { text: 'Section', value: 'Section' }
            ],
            isLoading : true, 
        };
    },

    methods: {
        goBack() {
            if (window.history.length > 1) {
                this.$router.go(-1); // Only go back if there's a history
            } else {
                this.$router.push({ name: "performancemoderationrecordlist" }); // Go to home if no history
            }
        },

        async loadPmModerationDetail() {
            this.isErr = false;
            this.errMsg = "";
            this.moderationdetail = []; // Reset the moderation detail
            try {
                const res = await this.$store.dispatch('get', { url: `/moderationDetail/${this.parentObject.data.id}/${this.parentObject.company}` });
                if (res.data.moderationDetail && res.data.moderationDetail.length > 0) {
                    this.moderationdetail = res.data.moderationDetail;
                    this.moderationdetail = res.data.moderationDetail.map(item => ({
                        ...item,
                        startdate: item.startdate ? moment(item.startdate).format('YYYY-MM-DD') : null,
                        enddate: item.enddate ? moment(item.enddate).format('YYYY-MM-DD') : null
                    }));
                } else {
                    this.isErr = true;
                    console.error("Data not found");
                    this.errMsg = "Record not found.";
                }
            } catch (err) {
                console.error("Error loading record:", err);
                this.isErr = true;
                this.errMsg = err.message || "Network Error";
            }
        },

        async loadPmRankMapSetDetailById() {
            this.isErr = false;
            this.errMsg = "";
            this.rankmapsetdetail = []; // Reset the rank map detail
            try {
                const res = await this.$store.dispatch('get', { url: `/rankmapsetdetails/${this.formData.ratingid}` });
                if (res.data.rec && res.data.rec.length > 0) {
                    this.rankmapsetdetail = res.data.rec;
                } else {
                    this.isErr = true;
                    console.error("Data not found");
                    this.errMsg = "Record not found.";
                }
            } catch (err) {
                console.error("Error loading record:", err);
                this.isErr = true;
                this.errMsg = err.message || "Network Error";
            }
        },

        async generateGroupedCharts() {
            if (!this.moderationdetail.length || !this.rankmapsetdetail.length) return;

            // Group data by selected type
            const groupedData = {};
            this.moderationdetail.forEach(item => {
                const groupKey = item[`${this.selectedGroupType.toLowerCase()}name`] || 'Unknown';
                
                if (!groupedData[groupKey]) {
                    groupedData[groupKey] = [];
                }
                groupedData[groupKey].push(item);
            });

            // Prepare charts data
            this.companyCharts = {};
            const rankCategories = this.rankmapsetdetail.map(item => item.rank);

            Object.keys(groupedData).forEach(groupName => {
                // Count ranks for this group
                const rankCounts = {};
                this.rankmapsetdetail.forEach(rank => {
                    rankCounts[rank.rank] = 0; // Initialize all possible ranks
                });

                // Count actual ranks in group
                groupedData[groupName].forEach(item => {
                    if (rankCounts[item.finalrank] !== undefined) {
                        rankCounts[item.finalrank]++;
                    }
                });

                // Prepare chart data
                this.companyCharts[groupName] = {
                    series: [{
                        name: this.$t('pmmoderation.headcount'),
                        data: Object.values(rankCounts)
                    }],
                    chartOptions: {
                        chart: { 
                            type: "line", 
                            zoom: { enabled: false },
                            toolbar: { show: false }
                        },
                        xaxis: { 
                            categories: rankCategories,
                            title: { text: this.$t('Setuprankmapset.rank') }
                        },
                        yaxis: {
                            title: { text: this.$t('pmmoderation.headcount') },
                            min: 0
                        },
                        dataLabels: { enabled: false },
                        stroke: { curve: 'straight' },
                        title: { 
                            // text: `${groupName}`,
                            text: ``,  
                            align: 'left', 
                            style: { color: '#3d4be3' } 
                        },
                        grid: { 
                            row: { 
                                colors: ['#f3f3f3', 'transparent'], 
                                opacity: 0.5 
                            } 
                        },
                        markers: { size: 5 },
                    }
                };
            });
        },

        goToGroupDetails(groupName) {//filter data ,using group
            this.$router.push({
                name: 'performancemoderationrecorddetailedit',
                params: { 
                    id: this.parentObject.data.id,
                    company: this.parentObject.company,
                    groupType: this.selectedGroupType,
                    groupName: groupName
                }
            });
        },


        goToCompanyDetails() { // full data from the company
            this.$router.push({
                name: 'performancemoderationrecorddetailfulledit',
                params: { 
                    id: this.parentObject.data.id,
                    company: this.parentObject.company,
                }
            });
        },
        
    },

    async mounted() {        
        await this.loadPmModerationDetail();
        await this.loadPmRankMapSetDetailById();
        await this.generateGroupedCharts();
        this.isLoading=false;//after load all data, then show page
    }
};
</script>
